import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getBusinessHealth } from '../../services/OrdersService';

const STATUS_STYLE = {
    green:  { alert: 'alert-success',  icon: '🟢' },
    yellow: { alert: 'alert-warning',  icon: '🟡' },
    red:    { alert: 'alert-danger',   icon: '🔴' }
};

/**
 * Health indicator DE NEGÓCIO (distinto do técnico no sidebar). Avalia
 * Win Rate, Profit Factor, Drawdown dos últimos 30 dias e mostra:
 *   🟢 Operação saudável — Win rate 64%, PF 1.85
 *   🟡 Atenção: Win rate em zona de atenção (48%)
 *   🔴 Profit factor 0.7 — perdendo mais do que ganha
 *
 * props:
 * - linkToPerformance: bool — default true. Se true, vira link clicável
 *   pro /performance (pra investigar). False = só banner.
 */
function BusinessHealthBanner({ linkToPerformance = true }) {
    const [health, setHealth] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getBusinessHealth()
            .then(h => { setHealth(h); setLoading(false); })
            .catch(() => setLoading(false));
    }, []);

    if (loading || !health) return null;

    const style = STATUS_STYLE[health.status] || STATUS_STYLE.green;

    const content = (
        <div className={`alert ${style.alert} py-2 mb-3 d-flex align-items-center justify-content-between`} role='alert'>
            <div>
                <span className='me-2'>{style.icon}</span>
                <strong>{health.headline}</strong>
                {health.details && health.details.length > 1 && (
                    <small className='d-block mt-1 text-muted'>
                        + {health.details.length - 1} {health.details.length === 2 ? 'outro alerta' : 'outros alertas'}
                    </small>
                )}
            </div>
            {linkToPerformance && (
                <small className='text-muted ms-2' style={{ fontSize: 12 }}>
                    ver detalhes →
                </small>
            )}
        </div>
    );

    if (linkToPerformance) {
        return (
            <Link to='/performance' style={{ textDecoration: 'none', color: 'inherit' }}>
                {content}
            </Link>
        );
    }
    return content;
}

export default BusinessHealthBanner;
